export default __webpack_public_path__ + "static/media/telco_active.25e84171.svg";